import { useContext, useEffect } from "react";
import HeatmapModal from "../Modal/HeatmapModal/HeatmapModal";
import HeatmapActions from "./Actions/HeatmapActions";
import Loader from "./Loader/Loader";
import { AppContext } from "../../Context/Context";
import useModalClose from "../../hooks/useModalClose";
import "../../assets/css/Heatmap/heatmapModal.css";
import { useDispatch, useSelector } from "react-redux";
import { setLoaderText } from "../../store/heatmapSlice";

const Heatmap = ({ closeModal }) => {
  const { setTimeRangePopup } = useContext(AppContext);

  const { isHeatmapDataAvailable } = useSelector((state) => state.heatmap);
  const dispatch = useDispatch();

  useEffect(() => {
    document.body.classList.add("prevent-scroll");
    return () => {
      dispatch(setLoaderText("Loading Heatmap..."));
    };
  }, []);

  const closeModalHandler = () => {
    closeModal();
    document.body.classList.remove("prevent-scroll");
    if (!isHeatmapDataAvailable) {
      setTimeRangePopup(true);
    }
  };

  useModalClose("heatmap-modal-id", closeModalHandler);

  return (
    <div id="heatmap-modal-id" className="heatmap-modal-wrapper">
      <div className="heatmap-modal-container">
        <HeatmapActions closeModal={closeModalHandler} />
        <Loader>
          <HeatmapModal />
        </Loader>
      </div>
    </div>
  );
};

export default Heatmap;
